import {
  SerializedChatPromptTemplateMessagesKwarg,
  convertManifestToMessages,
  extractTemplateFormatFromKwargs,
} from '@/Pages/Playground/components/manifest/serialized/prompts/ManifestChatPromptTemplate.utils';
import { StructuredPromptSchema } from '@/Pages/Playground/components/manifest/serialized/prompts/ManifestStructuredPrompt';
import { EditableMessage } from '@/components/EditableMessage';
import { EditInputFunctionParameters } from '@/components/ExampleCrudPane/EditInputFunctions';
import { SchemaEditorVariant } from '@/components/SchemaEditor/types';
import { MessageUnionType } from '@/types/schema';

import { JsonMessageDiff, RenderDiff } from '../Diffs';
import { GetMessageDiffsArgs, StoredMessageDiffsRecord } from '../types';

export const CommitChatPromptManifest = ({
  kwargs,
}: {
  kwargs: Record<string, unknown> & {
    messages: SerializedChatPromptTemplateMessagesKwarg;
    schema_?: StructuredPromptSchema;
  };
}) => {
  const msgs = convertManifestToMessages(kwargs.messages);
  const schema = kwargs.schema_;

  return (
    <>
      {msgs.map((message, idx) => {
        return (
          <div key={idx} className="cursor-pointer rounded-lg">
            <EditableMessage
              variant="template"
              messageValue={message}
              onChange={() => null}
              hideSyntaxHighlighting={false}
              templateFormat={
                extractTemplateFormatFromKwargs(kwargs) ?? 'f-string'
              }
              readOnly
            />
          </div>
        );
      })}
      {schema && (
        <EditInputFunctionParameters
          variant={SchemaEditorVariant.SCHEMA}
          value={schema}
          showEditorSelector
          showBorder={true}
          readOnly
        />
      )}
    </>
  );
};

export const CommitChatPromptDiff = ({
  commitId,
  getMessageDiffs,
  currentCommitMsgs,
  previousCommitMsgs,
  currentCommitSchema,
  previousCommitSchema,
}: {
  commitId: string;
  getMessageDiffs: (args: GetMessageDiffsArgs) => StoredMessageDiffsRecord;
  currentCommitMsgs: MessageUnionType[];
  previousCommitMsgs: MessageUnionType[];
  currentCommitSchema?: StructuredPromptSchema;
  previousCommitSchema?: StructuredPromptSchema;
}) => {
  const { messageDiffs, schemaDiffs, messageTypeDiffs } = getMessageDiffs({
    commitId,
    previousCommitMsgs,
    currentCommitMsgs,
    previousCommitSchema,
    currentCommitSchema,
  });

  return (
    <>
      {messageDiffs.map((d, i) => (
        <RenderDiff diffs={d} messageType={messageTypeDiffs[i]} key={i} />
      ))}
      {schemaDiffs && <JsonMessageDiff diffs={schemaDiffs} title="Schema" />}
    </>
  );
};
